import styled from "styled-components";
export const CaseStudiesListContainer = styled.div`
  max-height: calc(100vh - 110px);
  overflow-y: auto;
  display: flex;
  padding:0 10px;
  flex-flow: column nowrap;
`;
